/**
 * templateData.js - Mock template data
 * 
 * Used for: Template list page, popular templates section
 * 
 * Categories:
 * - İş Hukuku
 * - Kira
 * - Ticari
 * - Bireysel
 * - Genel
 */

export const templateData = [
  {
    id: 1,
    title: 'İş Sözleşmesi',
    description: 'Çalışanlarınız için standart iş sözleşmesi oluşturun',
    category: 'İş Hukuku',
    icon: '📄',
  },
  {
    id: 2,
    title: 'Kira Sözleşmesi',
    description: 'Ev veya işyeri kira sözleşmesi hazırlayın',
    category: 'Kira',
    icon: '🏠',
  },
  {
    id: 3,
    title: 'Gizlilik Sözleşmesi (NDA)',
    description: 'Taraflar arası gizlilik anlaşması oluşturun',
    category: 'Ticari',
    icon: '🔒',
  },
  {
    id: 4,
    title: 'İhtar Mektubu',
    description: 'Hukuki ihtar mektubu hazırlayın',
    category: 'Genel',
    icon: '⚠️',
  },
  {
    id: 5,
    title: 'Hizmet Sözleşmesi',
    description: 'Hizmet alım-satım sözleşmesi oluşturun',
    category: 'Ticari',
    icon: '🤝',
  },
  {
    id: 6,
    title: 'İstifa Dilekçesi',
    description: 'İş akdinden ayrılma dilekçesi hazırlayın',
    category: 'İş Hukuku',
    icon: '📝',
  },
  {
    id: 7,
    title: 'Vekaletname',
    description: 'Yasal işlemler için vekaletname oluşturun',
    category: 'Bireysel',
    icon: '✍️',
  },
  {
    id: 8,
    title: 'Ortaklık Sözleşmesi',
    description: 'İş ortaklığı sözleşmesi hazırlayın',
    category: 'Ticari',
    icon: '🏢',
  },
  {
    id: 9,
    title: 'Borç Taahhütnamesi',
    description: 'Borç ödeme taahhüdü belgesi oluşturun',
    category: 'Genel',
    icon: '💰',
  },
  {
    id: 10,
    title: 'İzin Belgesi',
    description: 'Çeşitli izin belgesi formları hazırlayın',
    category: 'Genel',
    icon: '📋',
  },
  {
    id: 11,
    title: 'Satış Sözleşmesi',
    description: 'Mal veya hizmet satış sözleşmesi oluşturun',
    category: 'Ticari',
    icon: '🛒',
  },
  {
    id: 12,
    title: 'İş Başvuru Formu',
    description: 'Çalışan adayları için başvuru formu hazırlayın',
    category: 'İş Hukuku',
    icon: '👤',
  },
  {
    id: 13,
    title: 'Fesih Bildirimi',
    description: 'İş sözleşmesi fesih bildirimi oluşturun',
    category: 'İş Hukuku',
    icon: '🚫',
  },
  {
    id: 14,
    title: 'Ön Ödeme Sözleşmesi',
    description: 'Peşinat veya ön ödeme sözleşmesi hazırlayın',
    category: 'Ticari',
    icon: '💳',
  },
  {
    id: 15,
    title: 'Muvafakatname',
    description: 'İzin ve onay belgesi oluşturun',
    category: 'Bireysel',
    icon: '✅',
  },
];

// Helper function to get all templates
export const getAllTemplates = () => {
  return templateData;
};

// Helper function to get templates by category
export const getTemplatesByCategory = (category) => {
  return templateData.filter(template => template.category === category);
};

// Helper function to get all categories
export const getAllCategories = () => {
  return [...new Set(templateData.map(template => template.category))];
};

